var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnreadMails(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83.525,
    height: 63.983,
    viewBox: "0 0 83.525 63.983",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "NieuwBerichtBinnen",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M82.982,11.9a8.994,8.994,0,0,0-1.861-3.45A9.692,9.692,0,0,0,73.717,5H11.692a9.692,9.692,0,0,0-7.4,3.45A8.994,8.994,0,0,0,2.426,11.9,9.343,9.343,0,0,0,2,14.692V53.458a9.692,9.692,0,0,0,9.692,9.692H73.717a9.692,9.692,0,0,0,9.692-9.692V14.692a9.344,9.344,0,0,0-.427-2.792ZM11.692,8.877H73.717A5.776,5.776,0,0,1,77.943,10.7L43.829,34.772a1.861,1.861,0,0,1-2.248,0L7.466,10.7A5.776,5.776,0,0,1,11.692,8.877ZM79.532,53.458a5.815,5.815,0,0,1-5.815,5.815H11.692a5.815,5.815,0,0,1-5.815-5.815V14.692a1.085,1.085,0,0,1,0-.349L39.293,37.951a5.776,5.776,0,0,0,6.745,0L79.532,14.343Z",
    transform: "translate(-2 0.834)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 8.373,
    cy: 8.373,
    rx: 8.373,
    ry: 8.373,
    transform: "translate(66.778 0)",
    fill: "red"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnreadMails);
export default __webpack_public_path__ + "static/media/UnreadMails.755a0df30694e243ca2e6dd1b8a402ab.svg";
export { ForwardRef as ReactComponent };